import {CalendarDay, Vacation, VacationRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell, Typography} from "@mui/material";
import {dateFromToString, dateToString} from "../../../../components/utils/dates";
import {fullName, SoftChip} from "../../../../components/kit";
import {VACATION_STATE, vacationTypeLabel} from "../../../employee/vacation/labels";
import {useApiManager} from "../../../../components/utils/api";
import {useSearchParams} from "react-router-dom";
import {parseParamId} from "../../../../components/form/form_utils";
import {useState} from "react";
import dayjs from "dayjs";


export const VacationsListPage = () => {
	const apiManager = useApiManager();
	let [searchParams, setSearchParams] = useSearchParams();
	let [calendar, setCalendar] = useState<CalendarDay[]>([]);

	const queryPersonId = parseParamId(searchParams, "personId");

	function countWorkingDays(startDate: string, endDate: string) {
		const format = 'YYYY-MM-DD';
		let currentDate = dayjs(startDate, format);
		const end = dayjs(endDate, format);
		let workingDays = 0;

		while (currentDate.valueOf() <= end.valueOf()) {
			let isWeekend = currentDate.day() === 0 || currentDate.day() === 6;
			let isHoliday = calendar
			.find(calDay => calDay.date == currentDate.format(format))
				?.holiday;

			if (!isWeekend && !isHoliday) {
				workingDays++;
			}

			currentDate = currentDate.add(1, 'days');
		}

		return workingDays;
	}

	const listConfig: AppListConfig<Vacation> = {
		title: "Ausencias",
		onClick: "/app/admin/employee/vacations",
		headers: [
			{title: "Período"},
			{title: "Persona"},
			{title: "Tipo"},
			{title: "Estado"},
			{title: "Título"},
			{title: "Validador"},
			{title: "Justificante"},
			{title: "Año", align: "right"},
		],
		decorator: (bean: Vacation) => (
			<>
				<TableCell>
					<Typography variant="body2" fontWeight={600} sx={{fontVariantNumeric: "tabular-nums"}}>
						{dateFromToString(bean.periodFrom)}
						{bean.periodTo && bean.periodTo !== bean.periodFrom ? ` – ${dateFromToString(bean.periodTo)}` : ""}
					</Typography>
					<Typography variant="caption" color="text.secondary">
						{countWorkingDays(bean.periodFrom, bean.periodTo)} días laborables
					</Typography>
				</TableCell>
				<TableCell>
					<Typography variant="body2" fontWeight={600} noWrap>{fullName(bean.person)}</Typography>
				</TableCell>
				<TableCell>
					{vacationTypeLabel(bean.type)}
				</TableCell>
				<TableCell>
					{bean.state && (
						<SoftChip label={VACATION_STATE[bean.state]?.label || bean.state}
								  tone={VACATION_STATE[bean.state]?.tone || "neutral"}/>
					)}
				</TableCell>
				<TableCell>
					<Typography variant="body2" noWrap title={bean.title}>{bean.title}</Typography>
				</TableCell>
				<TableCell>
					{bean.validator ? fullName(bean.validator) : ""}
				</TableCell>
				<TableCell>
					{bean.justificationCheckedDate && (
						<SoftChip tone="success" label={`Visto ${dateToString(bean.justificationCheckedDate)}`}/>
					)}
				</TableCell>
				<TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
					{bean.imputationYear}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(VacationRestControllerApiFactory);
			return ctrl.pageVacation(currentPage, size, undefined, queryPersonId,
				undefined, undefined, undefined, term, showDismissed)
			.then(resp => {
				let days: string[] = []
				resp.data.content?.forEach(vacation => {
					days.push(vacation.periodFrom)
					days.push(vacation.periodTo)
				});
				days = days.sort();
				const start = days[0];
				const end = days[days.length - 1];
				ctrl.getHolidayCalendarVacation(start, end).then(calResp => {
					setCalendar(calResp.data);
				})
				return resp;
			});
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};